/**
 * Composable para rastrear automaticamente componentes acima da dobra
 * Os 2 primeiros componentes ÚNICOS com imagens serão marcados como "above fold"
 * Múltiplas instâncias do mesmo componente contam como 1 só
 */

export const ABOVE_FOLD_LIMIT = 2; // Quantos componentes devem ter eager loading

const state = reactive({
  componentCounter: 0,
  registeredComponents: new Set<string>(),
});

export const useAboveFoldTracking = () => {
  /**
   * Registra um componente e retorna se ele está acima da dobra
   * Os primeiros N componentes ÚNICOS registrados serão considerados "above fold"
   *
   * @param componentName - Nome único do componente (ex: 'TabsApostatudo', 'Recommended')
   */
  const registerComponent = (componentName: string): boolean => {
    // Se já foi registrado, retorna false (não conta novamente)
    if (registeredComponents.has(componentName)) {
      return false;
    }

    // Marca como registrado
    registeredComponents.add(componentName);
    componentCounter++;

    return componentCounter <= ABOVE_FOLD_LIMIT;
  };

  /**
   * Reseta o contador e componentes registrados (útil para navegação SPA)
   */
  const resetTracking = () => {
    state.componentCounter = 0;
    state.registeredComponents.clear();
  };

  return {
    registerComponent,
    resetTracking,
  };
};
